import CoreStructure from './core';
import LoginComponent from './login';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './core/common/components/UserContext';
import AppProviders from './core/common/AppProviders.js';
import LoadingComponent from './core/common/loading.js';
import './App.css';
import api from './core/common/api.js';

import ForgotPasswordComponent from './login/forgotPassword';
import ResetPasswordComponent from './login/resetPassword';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();
  
  if (loading) {
    return <LoadingComponent />;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  // Get the base path from environment variables
  const basePath = process.env.REACT_APP_BASE_PATH || '/';
  
  return (
    <AppProviders>
      <UserProvider>
        <BrowserRouter basename={basePath}>
          <Routes>
            <Route path="/login" element={<LoginComponent />} />
            <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
            <Route path="/reset-password" element={<ResetPasswordComponent />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <CoreStructure />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </UserProvider>
    </AppProviders>
  );
}


export default App;